import { motion } from 'framer-motion';
import { Phone, Shield, Clock, Award } from 'lucide-react';

const WHATSAPP_NUMBER = "5521980277322";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_neon-fix-dark/artifacts/j4zm2tv7_logo%20vaz%20tech.jpeg";

export const Hero = () => {
  const features = [
    { icon: Shield, text: "Garantia em todos os serviços" },
    { icon: Clock, text: "Atendimento rápido e eficiente" },
    { icon: Award, text: "Técnicos certificados" },
  ];

  return (
    <section className="hero-bg min-h-screen flex items-center pt-32 md:pt-40 pb-20" data-testid="hero-section">
      <div className="hero-content max-w-7xl mx-auto px-6 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block mb-6">
              <span className="text-[#00F0FF] text-sm font-mono uppercase tracking-widest border border-[#00F0FF]/30 px-4 py-2 bg-[#00F0FF]/5">
                [ Assistência Técnica Especializada ]
              </span>
            </div>
            
            <h1 className="font-orbitron text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Soluções{' '}
              <span className="text-[#00F0FF] neon-text">Avançadas</span>
              <br />
              Para Seus Dispositivos
            </h1>
            
            <p className="text-[#94A3B8] text-lg md:text-xl font-space leading-relaxed mb-8 max-w-xl">
              Reparo de celulares, notebooks, smartwatches e computadores com tecnologia de ponta. 
              iPhone, Samsung, Xiaomi, Apple Watch, Garmin e muito mais.
            </p>

            {/* Features */}
            <div className="flex flex-wrap gap-6 mb-10">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  className="flex items-center gap-3"
                >
                  <div className="w-10 h-10 border border-[#00F0FF]/30 flex items-center justify-center bg-[#00F0FF]/5">
                    <feature.icon size={18} className="text-[#00F0FF]" />
                  </div>
                  <span className="text-sm text-[#94A3B8] font-space">{feature.text}</span>
                </motion.div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.a
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Vim pelo site e preciso de assistência técnica.`}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="whatsapp-btn justify-center text-base"
                data-testid="hero-whatsapp-btn"
              >
                <Phone size={20} />
                Falar com Especialista
              </motion.a>
              
              <motion.a
                href="#servicos"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="cyber-btn text-center text-base"
                data-testid="hero-services-btn"
              >
                Ver Serviços
              </motion.a>
            </div>
          </motion.div>

          {/* Logo/Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:flex justify-center items-center"
          >
            <div className="relative">
              {/* Glow effect behind logo */}
              <div className="absolute inset-0 bg-[#00F0FF]/10 blur-3xl rounded-full transform scale-150"></div>
              <img 
                src={LOGO_URL} 
                alt="Vaz Tech Solutions" 
                className="relative z-10 w-full max-w-md animate-float"
              />
            </div>
          </motion.div>
        </div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          {[
            { number: "5000+", label: "Dispositivos Reparados" },
            { number: "98%", label: "Clientes Satisfeitos" },
            { number: "10+", label: "Anos de Experiência" },
            { number: "24h", label: "Tempo Médio de Reparo" },
          ].map((stat, index) => (
            <div key={index} className="text-center" data-testid={`stat-${index}`}>
              <div className="stat-number">{stat.number}</div>
              <div className="text-[#94A3B8] text-sm font-space mt-2">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
